import { type Components } from '@webapp/api/integrations/client'
import { IntegrationServicePlatforms } from '@webapp/models/enums'

export const getCurrentSageEnvironment = (
  existingServiceIntegrations: Components.Schemas.IntegrationResponse[]
) => {
  if (!existingServiceIntegrations) {
    return IntegrationServicePlatforms.MERGE_SAGE_INTACCT // Default for new setups
  }

  const hasCodatSageIntegration = existingServiceIntegrations.some(
    (integration) =>
      integration.name === IntegrationServicePlatforms.SAGE_INTACCT
  )

  const hasMergeSageIntegration = existingServiceIntegrations.some(
    (integration) =>
      integration.name === IntegrationServicePlatforms.MERGE_SAGE_INTACCT
  )

  if (!hasCodatSageIntegration || hasMergeSageIntegration) {
    return IntegrationServicePlatforms.MERGE_SAGE_INTACCT
  }

  return IntegrationServicePlatforms.SAGE_INTACCT
}
